import { useState } from "react";

import { formatCurrency } from "../../../../lib/script";
import CheckboxCell from "../../../common/interactive/CheckboxCell";
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency";


// item balance is replaced by negotiated amount 
// and since there are 2 for liability and umPolicyLimitsOptions, 
// need to chose based on source field from the aprent component 
// if there is no neg amount, balance will be used

export default function NewPaymentFormTableItem({item, modifyItem, totalItems, totalAmount, selectedSource}) {

    const [isManual, setIsManual] = useState(false)
    const [manualAmount, setManualAmount] = useState(0)

    function selectSourceToUse(source) {
        switch (source) {
            case 'Liability':
                return 'lia_neg_amount'
            case 'UM':
                return 'um_neg_amount'         
            default:
                return 'balance'
        }
    }

    function setManualHandler(data) {
        setIsManual(prev => prev = !prev)

        if (modifyItem) {
            modifyItem(item.id, manualAmount, data.data.value)
        }
    }

    function setManualAmountHandler(data) {
        setManualAmount(data.data.value)

        if (modifyItem) {
            modifyItem(item.id, data.data.value, isManual)
        }
        
    }

   
    return <tr key={item.value}>
        <td>{item.label}</td>
        <td>
            ${formatCurrency(item[selectSourceToUse(selectedSource)])}
            
            {/* ${formatCurrency(item.balance)} */}
        </td>
        <td>
            {/* {!item.is_manual && <>
                {totalItems > 1 ? <>${item.amount > item.balance ? formatCurrency(item.balance) : formatCurrency(item.amount)}</> : 
                    <>${totalAmount > item.balance ? formatCurrency(item.balance) : formatCurrency(totalAmount)}</>
                }
            </>} */}
            {!item.is_manual && <>
                {totalItems > 1 ? <>${item.amount > item[selectSourceToUse(selectedSource)] ? formatCurrency(item[selectSourceToUse(selectedSource)]) : formatCurrency(item.amount)}</> : 
                    <>${totalAmount > item[selectSourceToUse(selectedSource)] ? formatCurrency(item[selectSourceToUse(selectedSource)]) : formatCurrency(totalAmount)}</>
                }
            </>}

            {/* {item.is_manual && <InputBoxCurrency action={setManualAmountHandler} currentValue={manualAmount} identifier={{type: null, field: 'manual_amount', type_id: null, folder: null}} maxValue={item.balance > Number(totalAmount) ? Number(totalAmount) : item.balance}/>} */}
            {item.is_manual && <InputBoxCurrency action={setManualAmountHandler} currentValue={manualAmount} identifier={{type: null, field: 'manual_amount', type_id: null, folder: null}} maxValue={item[selectSourceToUse(selectedSource)] > Number(totalAmount) ? Number(totalAmount) : item[selectSourceToUse(selectedSource)]}/>}
        </td>
        <td>
            <CheckboxCell action={setManualHandler} checked={item.is_manual} setStyle={'centered'} identifier={{type: null, field: 'manual', type_id: null, folder: null}} />
        </td>
    </tr>
}